import { Box, Tooltip } from "@mui/material"
import copy from "copy-to-clipboard"
import { ReactElement, useState } from "react"

type CopyToClipboardProps = {
  text: string
  children: ReactElement
}

const CopyToClipboard = ({ text, children }: CopyToClipboardProps) => {
  const [copiedText, setCopiedText] = useState<string>("")

  const handleClickCopy = () => {
    copy(text)
    setCopiedText(text)
  }

  return (
    <Tooltip title={copiedText === text ? "Copied" : "Copy To Clipboard"}>
      <Box sx={{ ":hover": { cursor: "pointer" } }} onClick={handleClickCopy}>
        {children}
      </Box>
    </Tooltip>
  )
}

export default CopyToClipboard
